import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { GlobeIcon } from 'lucide-react';
import { exchangeRates } from '../data/bankData';
const VISIBLE = 5;
export function ExchangeRates() {
  const [index, setIndex] = useState(0);
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => {
      setIndex(i => (i + 1) % exchangeRates.length);
    }, 3000);
    return () => clearInterval(id);
  }, []);
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const window = Array.from({
    length: VISIBLE
  }, (_, o) => ({
    ...exchangeRates[(index + o) % exchangeRates.length],
    slot: o
  }));
  const timeStr = new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).format(now);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.7,
    delay: 0.45,
    ease: [0.22, 1, 0.36, 1]
  }} className="relative overflow-hidden rounded-2xl h-full shadow-[0_8px_30px_-8px_rgba(0,0,0,0.6)]" style={{
    background: 'linear-gradient(90deg, #001a33 0%, #002a52 50%, #001a33 100%)',
    border: '1px solid rgba(127,181,57,0.25)'
  }} data-id="element-61">
      {/* solid accent top edge */}
      <div className="absolute inset-x-0 top-0 h-[2px] bg-gradient-to-r from-[#0066B3] via-[#7FB539] to-[#0066B3]" data-id="element-62" />

      <div className="relative flex items-stretch h-full" data-id="element-63">
        {/* Header chunk — solid brand block */}
        <div className="flex items-center gap-3 px-5 shrink-0 min-w-[230px]" style={{
        background: 'linear-gradient(90deg, #0066B3, #003F7D)'
      }} data-id="element-64">
          <div className="flex items-center justify-center h-11 w-11 rounded-xl bg-white/15 border border-white/25" data-id="element-65">
            <GlobeIcon className="h-6 w-6 text-white" data-id="element-66" />
          </div>
          <div data-id="element-67">
            <div className="tracking-display text-lg font-bold text-white leading-tight" data-id="element-68">
              EXCHANGE RATES
            </div>
            <div className="flex items-center gap-2 mt-0.5" data-id="element-69">
              <span className="relative inline-flex h-2 w-2 rounded-full bg-[#7FB539] pulse-dot" data-id="element-70" />
              <span className="text-[11px] uppercase tracking-[0.2em] text-white font-bold" data-id="element-71">
                Live
              </span>
              <span className="font-mono-num text-[11px] text-white/85 font-semibold" data-id="element-72">
                {timeStr}
              </span>
            </div>
          </div>
        </div>

        {/* Column legend strip */}
        <div className="flex items-center px-4 shrink-0 border-r border-white/10 bg-black/20" data-id="element-73">
          <div className="flex flex-col gap-1.5 text-right" data-id="element-74">
            <div className="text-[11px] uppercase tracking-[0.18em] text-white font-bold leading-none" data-id="element-75">
              BUY
            </div>
            <div className="text-[11px] uppercase tracking-[0.18em] text-[#9ed957] font-bold leading-none" data-id="element-76">
              SELL
            </div>
          </div>
        </div>

        {/* Currency cells — solid, high contrast */}
        <div className="flex-1 grid grid-cols-5" data-id="element-77">
          {window.map((r, idx) => <div key={r.slot} className="relative overflow-hidden flex items-center px-4" style={{
          borderRight: idx < VISIBLE - 1 ? '1px solid rgba(255,255,255,0.08)' : 'none'
        }} data-id="element-78">
              <AnimatePresence initial={false} mode="popLayout" data-id="element-79">
                <motion.div key={`${r.code}-${index}`} initial={{
              y: 50,
              opacity: 0
            }} animate={{
              y: 0,
              opacity: 1
            }} exit={{
              y: -50,
              opacity: 0
            }} transition={{
              duration: 0.6,
              ease: [0.22, 1, 0.36, 1],
              delay: r.slot * 0.04
            }} className="flex items-center justify-between gap-3 w-full" data-id="element-80">
                  <div className="flex items-center gap-3 min-w-0" data-id="element-81">
                    <span className="text-3xl leading-none" data-id="element-82">{r.flag}</span>
                    <div className="tracking-display text-2xl font-extrabold text-white leading-none" data-id="element-83">
                      {r.code}
                    </div>
                  </div>
                  <div className="flex flex-col items-end shrink-0" data-id="element-84">
                    <div className="font-mono-num text-xl font-extrabold text-white leading-none" data-id="element-85">
                      {r.buy.toFixed(2)}
                    </div>
                    <div className="font-mono-num text-lg font-extrabold text-[#9ed957] leading-none mt-1.5" data-id="element-86">
                      {r.sell.toFixed(2)}
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </motion.div>;
}